import { Injectable } from '@angular/core'
import { HttpResponse } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private cache = new Map<string, HttpResponse<any>>()

  addToCache(url: string, response: HttpResponse<any>) {
    this.cache.set(url, response)
  }

  getFromCache(url: string): HttpResponse<any> | undefined {
    return this.cache.get(url)
  }

  removeFromCache(url: string) {
    this.cache.forEach((key, value) => {
      if (value.includes(url)) {
        this.cache.delete(value)
      }
    })
  }

  clearAll() {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key && key.startsWith('sispg')) {
        localStorage.removeItem(key)
      }
    }
  }

  clearSearch() {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key && key.startsWith('sispg') && key.endsWith('search')) {
        localStorage.removeItem(key)
      }
    }
  }
}
